module.exports = __webpack_public_path__ + "static/img/my-bg.fe381b6d.png";